import { Eye, Heart, Lock, Play, ScanLine, Shuffle } from "lucide-react";
import type { LandingContent } from "../content/types";

type FeatureCardProps = LandingContent["features"][number];

const icons = {
  scan: ScanLine,
  eye: Eye,
  play: Play,
  shuffle: Shuffle,
  heart: Heart,
  lock: Lock
};

export function FeatureCard({ title, description, icon }: FeatureCardProps) {
  const Icon = icons[icon];

  return (
    <article className="feature-card">
      <div className="feature-icon" aria-hidden="true">
        <Icon size={20} strokeWidth={2} />
      </div>
      <div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </article>
  );
}
